import React, { useState, useContext, useEffect } from 'react';
import acm from '../AddCarModal.module.css'
import Select from "react-select";
import { useUser } from '../../../../../hooks/useUser';
import { selectStyle } from './selectStyle';
import { AppContext } from "../../../../../providers/appProvider";
import { useAuth } from '../../../../../providers/authProvider';
import MultiSelect from '../../../../UI/Inputs/MultiSelect';
import { useTranslation } from 'react-i18next';
import { baseFileURL } from '../../../../../Api';

const AddCarForm = ({ newCar, setNewCar, validates, isAdd }) => {
    const { t } = useTranslation();
    const { appState, app } = useContext(AppContext);

    const dealerLabel = (dealer) => {
        const fullname = `${dealer.firstname || ''} ${dealer.lastname || ''}`.trim();
        const companyname = dealer.companyName || dealer.companyname || '';

        return [fullname, `${companyname}`.trim()].filter(Boolean).join(' ');
    };
    
    let fakeDealers = [];

    appState.salers.forEach(saler => {
        const fakeDealer = {
            id: 0,
            saler_id: saler.id,
            firstname: t("ClientWithoutDealer"),
            lastname: "",
            name: t("ClientWithoutDealer")
        };

     fakeDealers.push(fakeDealer);
    });


    var readyDealers = [...fakeDealers, ...appState.dealers.map(dealer => ({ ...dealer, name: dealerLabel(dealer) }))];
  
    const additionalDealer = { value: 0, label: t("ClientWithoutDealer") };
    const modifiedDealers = [additionalDealer, ...appState.dealers.map(dealer => ({ value: dealer.id, label: dealerLabel(dealer) }))];
 
    const dealers = readyDealers.map((dealer) => ({ value: dealer.id, label: dealer.name }));

 
    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',  
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };


 


    
 
    const setModel = async (salerId, dealerId) => { 
      let clientTransferFee = 0  

        if (dealerId > 0 && (newCar.website_id === 1 || newCar.website_id === 2 || newCar.website_id === 3 || newCar.website_id === 24 )) {
                clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(newCar.client_price_car * 0.0015), 15 ) ;
        } else {
                clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(newCar.client_price_car * 0.0015), 60) ;
        }


        setNewCar({
            ...newCar, 
            saler_id:  salerId,
            dealer_id: dealerId,
            client_price_transfer_fee: clientTransferFee,
            saler_price_transfer_fee: clientTransferFee,

        })

        if (dealerId < 0 ) {
            setNewCar({
                ...newCar, 
                client_price_dealer:  0,
                saler_price_dealer:  0,
                car_price_dealer:  0,
                client_price_transfer_fee: clientTransferFee,
                saler_price_transfer_fee: clientTransferFee,
              });
        }
    } 

    return (
        <div>
            <fieldset className={acm.formField} style={{ paddingTop: '12px', paddingBottom: '12px',  marginBottom: '32px', }}>
 
              {app.hasPermission("ADD_FINANCE_SUPER") && 
                    <>

                        <MultiSelect
                            parentOptions={appState.salers}
                            childOptions={readyDealers}
                            parentId={newCar.saler_id}
                            childId={newCar.dealer_id}
                            styles={selectStyle}
                            onChange={setModel}
                            join={"saler_id"}
                            placeholder={t("Saler")}
                            placeholderSub={t("Dealer")}
                            fullWidth={true}
                            topTitle={true}
                            validate={validates && validates.saler_id ? true : false}
                            validateSub={validates && validates.dealer_id ? true : false}
                            parentIsPerson={true}
                            childIsPerson={false}
                        /> 
                    </>
                }

 
               {!app.hasPermission("ADD_FINANCE_SUPER") && 
                    <>
 
                        <div className={acm.inp2colCar}>
 
                            <div style={{ width: "25%" }}>
                                <div className={acm.comTitle}>
                                    {t("Dealer")}
                                </div>
                            </div>
                             <div style={{ width: "75%" }}>
                                <Select
                                    styles={validates && validates.dealer_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                    options={modifiedDealers}
                                    placeholder={t("Dealer")}
                                    value={dealers.find(option => option.value === newCar.dealer_id)}
                                    onChange={(selectedOption) => {
                                        let clientTransferFee = 0  

                                        if (selectedOption.value > 0 && (newCar.website_id === 'COPART.COM' || newCar.website_id === 'MANHEIM.COM' || newCar.website_id === 'IAAI.COM' || newCar.website_id === 'PIPELINE')) {
                                                clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(newCar.client_price_car * 0.0015), 15 ) ;
                                        } else {
                                                clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(newCar.client_price_car * 0.0015), 60) ;
                                        }
                                        
                                        setNewCar(prevState => ({
                                            ...prevState,
                                            dealer_id: selectedOption ? selectedOption.value : -1,
                                            client_price_transfer_fee: clientTransferFee,
                                            saler_price_transfer_fee: clientTransferFee,

                                        }));
                                    }}
                                    isClearable={true}
                                />
                            </div>
                        </div></>
                }



            </fieldset>
        </div>
    );
};

export default AddCarForm;
